import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { OutlineActionButton, ActionButtonBadge } from '../../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';

import { PurchaseStyles } from '../purchase/Purchase.styles';
import {
  offlineRequestsResetData,
  purchaseInsuranceRequest,
} from '../../features/purchases/purchasesActions';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import WaitingForPaymentStatusV2 from '../../common/components/redesignComponents/Purchase/WaitingForPaymentStatusV2';
import InfoBoxOfflineRequest from '../../common/components/redesignComponents/Purchase/common/InfoBoxOfflineRequest';
// import CompletedScreenOnline from './CompletedScreenOnline';
import CompletedScreen from '../../common/components/redesignComponents/Purchase/CompletedScreen';
import SentToCompanyAlert from '../purchase/SentToCompanyAlert';
import KoStatusAlert from '../purchase/KoStatusAlert';
import PendingIssuanceAlert from '../purchase/PendingIssuanceAlert';
import { purchase_statues } from '../../common/constants';
import ConversationModal from '../../common/components/redesignComponents/Modal/ConversationModal';

function PurchaseOfflineRequest() {
  const { requestToken } = useParams();
  const {
    loading,
    quote,
    insuranceRequest,
    quoteStatus,
    backofficeUsers,
    rc_quotation,
    speseLegaliFamigliaQuote,
    incendioContenutoQuote,
    danniFamigliaConduzioneQuote,
    danniPropietarioQuote,
    incendioFabbricatoQuote,
    risk_quotations,
    cauzioni,
    thread,
  } = useSelector((store) => store.purchases.offline_insurances);
  const [supportMessage, setSupportMessage] = useState({
    subject: '',
    request_id: '',
    body: '',
    recipient: '',
  });

  const [showConversationModal, setShowConversationModal] = useState(false);

  const collectQuoteData = async () => {
    purchaseInsuranceRequest(requestToken, 'offline', setSupportMessage);
  };

  const silentRefresh = () => purchaseInsuranceRequest(requestToken, 'offline', setSupportMessage, null, false);

  useEffect(() => {
    collectQuoteData();

    return () => {
      offlineRequestsResetData();
    };
  }, []);

  if (loading) {
    return <PageLoading />;
  }

  return (
    <>
      {showConversationModal && (
        <ConversationModal
          requestId={insuranceRequest?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_offline_purchase"
        />
      )}
      <PurchaseStyles>
        {quoteStatus !== 7 && (
          <>
            <div className="container mt-0">
              <InfoBoxOfflineRequest
                rc_quotation={rc_quotation}
                statuses={purchase_statues}
                insuranceRequest={insuranceRequest}
                quoteStatus={quoteStatus}
                messagesModalData={{
                  backofficeUsers,
                  setSupportMessage,
                  supportMessage,
                  collectData: collectQuoteData,
                }}
                risk_quotations={risk_quotations}
              />
              <div className="d-flex align-items-center justify-content-end mt-3">
                <OutlineActionButton
                  type="button"
                  onClick={() => {
                    setShowConversationModal(true);
                    if (thread?.unreadMessages > 0) silentRefresh();
                  }}
                >
                  <ChatIcon />
                  Contatta il Backoffice
                  {thread?.unreadMessages > 0 && (
                    <ActionButtonBadge>
                      {thread.unreadMessages}
                      <span className="visually-hidden">messaggi non letti</span>
                    </ActionButtonBadge>
                  )}
                </OutlineActionButton>
              </div>
              {cauzioni && (
                <div className="card mt-3">
                  <div className="card-body">
                    <h5 className="card-title mb-3">Dettagli Fideiussione / Cauzione</h5>
                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <small className="text-muted">Prodotto</small>
                        <p className="mb-0 fw-bold">{cauzioni.sub_product_name}</p>
                      </div>
                      <div className="col-md-6 mb-2">
                        <small className="text-muted">Garanzia</small>
                        <p className="mb-0 fw-bold">{cauzioni.risk_name}</p>
                      </div>
                      <div className="col-md-6 mb-2">
                        <small className="text-muted">Decorrenza</small>
                        <p className="mb-0">{cauzioni.effective_date ? new Date(cauzioni.effective_date).toLocaleDateString('it-IT') : '-'}</p>
                      </div>
                      <div className="col-md-6 mb-2">
                        <small className="text-muted">Scadenza</small>
                        <p className="mb-0">{cauzioni.expiry_date ? new Date(cauzioni.expiry_date).toLocaleDateString('it-IT') : '-'}</p>
                      </div>
                      <div className="col-md-6 mb-2">
                        <small className="text-muted">Somma garantita</small>
                        <p className="mb-0 fw-bold">
                          {cauzioni.guaranteed_amount != null
                            ? `€ ${Number(cauzioni.guaranteed_amount).toLocaleString('it-IT', { minimumFractionDigits: 2 })}`
                            : '-'}
                        </p>
                      </div>
                      <div className="col-md-6 mb-2">
                        <small className="text-muted">Beneficiario</small>
                        <p className="mb-0">{cauzioni.beneficiary_business_name || '-'}</p>
                      </div>
                      {cauzioni.description && (
                        <div className="col-12 mb-2">
                          <small className="text-muted">Descrizione</small>
                          <p className="mb-0">{cauzioni.description}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {quoteStatus === 4 && (
                <WaitingForPaymentStatusV2
                  quote={quote}
                  rc_quotation={rc_quotation}
                  spese_legali_famiglia_quote={speseLegaliFamigliaQuote}
                  incendio_contenuto_quote={incendioContenutoQuote}
                  danni_famiglia_conduzione_quote={danniFamigliaConduzioneQuote}
                  danni_propietario_quote={danniPropietarioQuote}
                  incendio_fabbricato_quote={incendioFabbricatoQuote}
                  insuranceRequest={insuranceRequest}
                  collectQuoteData={collectQuoteData}
                  assistenza_quotation={null}
                  rivalsa_quotation={null}
                  infortuni_conducente_quotation={null}
                  cristalli_quotation={null}
                  risk_quotations={risk_quotations}
                />
              )}

              {quoteStatus === 6 && <PendingIssuanceAlert />}
              {/* {quoteStatus === 6 && (
                <div className="card-body mt-3">
                  <div className="row">
                    <div className="col-6 offset-3">
                      <div className="alert alert-success" role="alert">
                        <h4 className="alert-heading">In Attesa Emissione</h4>
                        <p>
                          Quando l'agente di backoffice carica la polizza,
                          riceverai una notifica e il contratto potrà essere
                          scaricato.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
              {quoteStatus === 8 && <SentToCompanyAlert />}
              {quoteStatus === 9 && <KoStatusAlert insuranceRequest={insuranceRequest} />}
            </div>
          </>
        )}
        {quoteStatus === 7 && (
          /* <CompletedScreenOnline
            rc_quotation={rc_quotation}
            customer={insuranceRequest.customer}
            quoteStatus={quoteStatus}
          /> */
          <CompletedScreen
            product="offline"
            quoteStatus={quoteStatus}
            insuranceRequest={insuranceRequest}
            rc_quotation={rc_quotation}
          />
        )}
      </PurchaseStyles>
    </>
  );
}

export default PurchaseOfflineRequest;
